import Breadcrumb from '@/components/feature/Breadcrumb';
import ContactForm from './components/ContactForm';
import { useDocumentMeta } from '@/hooks/useDocumentMeta';

const channels = [
  { icon: 'ri-mail-line', label: '反馈邮箱', value: 'hello@midnight-video.demo' },
  { icon: 'ri-customer-service-2-line', label: '合作咨询', value: 'partner@midnight-video.demo' },
  { icon: 'ri-time-line', label: '回复时间', value: '工作日 24 小时内回复' },
];

const socials = [
  { icon: 'ri-wechat-fill', label: '微信' },
  { icon: 'ri-weibo-fill', label: '微博' },
  { icon: 'ri-bilibili-fill', label: '哔哩哔哩' },
  { icon: 'ri-mail-fill', label: '邮件订阅' },
];

export default function Contact() {
  useDocumentMeta({
    title: '联系我们 - 午夜视频 feedback 与商务合作',
    description:
      '联系午夜视频：通过反馈表单、邮箱或社交媒体与我们取得联系。欢迎提交内容建议、问题反馈与合作咨询，我们会尽快回复。',
    keywords: '联系午夜视频,午夜视频反馈,影视平台合作,联系我们',
  });

  return (
    <div className="pt-16 md:pt-20">
      <section className="border-b border-background-200 bg-background-100">
        <div className="px-4 md:px-8 py-10 md:py-14">
          <Breadcrumb items={[{ label: '首页', to: '/' }, { label: '联系我们' }]} />
          <h1 className="mt-4 font-heading text-3xl md:text-4xl font-bold text-foreground-950">
            联系我们
          </h1>
          <p className="mt-4 max-w-3xl text-sm md:text-base leading-relaxed text-foreground-600">
            无论是内容建议、问题反馈还是商务合作，我们都非常乐意听到你的声音。填写表单或通过下方任意方式联系我们。
          </p>
        </div>
      </section>

      <section className="px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-8">
          <div className="lg:col-span-3">
            <ContactForm />
          </div>

          <aside className="lg:col-span-2 space-y-4">
            <div className="rounded-lg border border-background-200 bg-background-100 p-6">
              <h2 className="font-heading text-lg font-bold text-foreground-950">联系方式</h2>
              <ul className="mt-5 space-y-4">
                {channels.map((c) => (
                  <li key={c.label} className="flex items-start gap-3">
                    <span className="w-10 h-10 shrink-0 flex items-center justify-center rounded-lg bg-primary-500/15 text-primary-400">
                      <i className={`${c.icon} text-xl`}></i>
                    </span>
                    <div>
                      <p className="text-xs text-foreground-500">{c.label}</p>
                      <p className="text-sm text-foreground-800 break-all">{c.value}</p>
                    </div>
                  </li>
                ))}
              </ul>
            </div>

            <div className="rounded-lg border border-background-200 bg-background-100 p-6">
              <h2 className="font-heading text-lg font-bold text-foreground-950">关注我们</h2>
              <div className="mt-4 grid grid-cols-2 gap-3">
                {socials.map((s) => (
                  <div
                    key={s.label}
                    className="flex items-center gap-2 rounded-lg bg-background-200/60 px-3 py-3 cursor-pointer hover:bg-background-300 transition-colors"
                  >
                    <i className={`${s.icon} text-xl text-accent-400`}></i>
                    <span className="text-sm text-foreground-800">{s.label}</span>
                  </div>
                ))}
              </div>
            </div>

            <div className="rounded-lg border border-primary-500/30 bg-primary-500/10 p-6">
              <p className="text-sm leading-relaxed text-foreground-800">
                <i className="ri-information-line text-primary-400 mr-1"></i>
                提示：本站影视内容均为演示数据，反馈表单仅用于演示提交，我们会认真阅读每一条留言。
              </p>
            </div>
          </aside>
        </div>
      </section>
    </div>
  );
}